import React from "react";
import OutdoorGameApp from "../games/outdoor/OutdoorGameApp";
import OnlineGameApp from "../games/online/OnlineGameApp";
import EscapeBoxGameApp from "../games/escape-box/EscapeBoxGameApp";
import { normalizeGameType } from "./gamePresentation";

const GAME_MODULES = Object.freeze({
  outdoor: OutdoorGameApp,
  online: OnlineGameApp,
  escape_box: EscapeBoxGameApp,
});

export default function GameLauncher({ gameType, children, ...moduleProps }) {
  const normalizedType = normalizeGameType(gameType);
  const GameModule = GAME_MODULES[normalizedType] || OutdoorGameApp;

  return (
    <GameModule {...moduleProps}>
      {children}
    </GameModule>
  );
}
